<template>
  <!-- 内部用户管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button
          class="topAn"
          type="primary"
          size="mini"
          plain
          @click="addUser"
        >
          <i class="el-icon-plus"></i>添加
        </el-button>
        <div>
          <div class="screening_box">
            <el-input
              v-model="createName"
              placeholder="请输入使用人/微信昵称"
              clearable
              @change="search"
            ></el-input>
            <!-- <el-input v-model="nickName" placeholder="请输入微信昵称" @change='search'></el-input> -->
          </div>
          <!-- 刷新按钮 -->
          <el-button
            :class="{ loadAn: loading }"
            icon="el-icon-refresh"
            circle
            size="mini"
            @click="initList"
          />
        </div>
      </div>
      <!-- 用户列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="选择" width="50">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                @change="selectUser"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="激活状态" width="80">
            <template slot-scope="scope">
              <span
                style="color: #999;"
                v-if="scope.row.isActivate != 1 && scope.row.isActivate != -1"
                >未激活</span
              >
              <span style="color: #67C23A;" v-if="scope.row.isActivate == 1"
                >已激活</span
              >
              <span style="color: #f00;" v-if="scope.row.isActivate == -1"
                >已过期</span
              >
            </template>
          </el-table-column>
          <el-table-column label="邀请码">
            <template slot-scope="scope">
              <span
                style="cursor: pointer;"
                v-clipboard:copy="scope.row.usercode"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                {{ scope.row.usercode }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createname"
            show-overflow-tooltip
            label="使用人"
          >
          </el-table-column>
          <el-table-column prop="nickName" label="微信昵称"> </el-table-column>
          <el-table-column label="有效时间" width="160">
            <template slot-scope="scope">
              <div class="time_item">
                <span v-if="scope.row.losestatus == 0">永久</span>
                <span v-else>{{ scope.row.losetime }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"> </el-table-column>
          <el-table-column prop="addon" width="200" label="创建时间">
          </el-table-column>
          <el-table-column align="right" label="操作" width="240">
            <template slot-scope="scope">
              <template>
                <el-button size="mini" @click.stop="binding(scope.row)">
                  绑定账号</el-button
                >
                <el-button
                  size="mini"
                  @click.stop="editWxUser(scope.$index, scope.row)"
                >
                  编辑</el-button
                >
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="deleteWxUser(scope.$index, scope.row)"
                >
                  <el-button slot="reference" size="mini" type="danger"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="paging_box">
        <span class="total">共{{ total }}条</span>
        <span class="perPage_num">本页{{ tableData.length }}条</span>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        >
        </el-pagination>
        <!-- 批量操作 -->
        <div class="batch_handle">
          <el-checkbox :indeterminate="!allChecked" v-model="allChecked"
            >全选</el-checkbox
          >
          <el-button
            class="batch_btn"
            size="mini"
            @click="handleBatch"
            v-if="batchBtnShow"
            >批量编辑</el-button
          >
        </div>
      </div>

      <!-- 查看绑定的账号 -->
      <el-dialog
        :title="createname"
        top="5vh"
        width="80%"
        :visible.sync="accountShow"
      >
        <!-- 按钮 -->
        <div class="add_wxUser">
          <p>共绑定{{ accountList.length }}家公司 {{ acc_num }}个账号</p>
          <el-button
            type="primary"
            size="mini"
            plain
            class="add_btn"
            @click="addAccount"
          >
            账号管理
          </el-button>
        </div>
        <!-- 列表 -->
        <ul class="account_list scrollbar" v-load="accLoading">
          <li v-for="(item, index) in accountList" :key="index">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>{{ item.companyname }}</span>
                <span class="num" v-if="item.users.length >= 3"
                  >（绑定了{{ item.users.length }}个账号）</span
                >
              </div>
              <ul class="user scrollbar">
                <li v-for="(user, i) in item.users" :key="i">
                  <span>{{ user.userName }}</span>
                  <el-popconfirm
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="delAccount(item, index, user, i)"
                  >
                    <i slot="reference" class="el-icon-delete del_icon"></i>
                  </el-popconfirm>
                </li>
              </ul>
            </el-card>
          </li>
        </ul>
        <div class="null_page" v-if="accountList.length == 0 && !accLoading">
          没有绑定账号
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="accountShow = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 账号弹窗 -->
      <el-dialog
        width="90%"
        title="账号管理"
        top="5vh"
        :close-on-click-modal="false"
        @close="innerVisible = false"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>
          <div class="content_head">
            <el-checkbox
              :indeterminate="!accountAll"
              v-model="accountAll"
              @change="selectAllAccount"
              >全选</el-checkbox
            >
            <div style="display: flex;" class="screening_box">
              <el-input
                style="margin-right:10px;"
                v-model="companyName"
                placeholder="请输入公司名称"
                clearable
                @change="searchAcc"
              ></el-input>
              <el-input
                v-model="userName"
                placeholder="请输入账号名称"
                clearable
                @change="searchAcc"
              ></el-input>
            </div>
          </div>
          <ul class="cascader_box scrollbar">
            <li
              :class="{ border_hint: company.show }"
              v-for="(company, index) in users"
              :key="index"
              v-show="!isScreen || company.show"
            >
              <el-checkbox
                class="checkAll"
                :indeterminate="!company.companyAll"
                v-model="company.companyAll"
                @change="selectCompanyAll($event, company)"
                >{{ company.companyname }}</el-checkbox
              >
              <div class="child_box">
                <el-checkbox-group v-model="company.activeUser">
                  <el-checkbox
                    v-for="(user, u_index) in company.users"
                    :label="user.userId"
                    :key="u_index"
                    border
                    size="mini"
                    @change="selectAccount($event, company)"
                    >{{ user.userName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </li>
          </ul>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="innerVisible = false">取 消</el-button>
          <el-button
            type="primary"
            size="mini"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="save"
            >保 存</el-button
          >
        </div>
      </el-dialog>

      <!-- 添加用户 -->
      <el-dialog
        width="40%"
        :title="!is_add ? '编辑使用人' : '添加使用人'"
        :close-on-click-modal="false"
        @close="cancelChangeWx"
        :visible.sync="userVisible"
        append-to-body
      >
        <el-form :model="wxName_form" :rules="rules" ref="wxName_form">
          <!-- 使用人 -->
          <el-form-item label="使用人" prop="createname">
            <el-input
              v-model="wxName_form.createname"
              placeholder="请输入使用人"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 手机号 -->
          <el-form-item label="手机号">
            <el-input
              maxlength="11"
              v-model="wxName_form.phone"
              placeholder="请输入手机号"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 是否永久 -->
          <el-form-item label="是否永久" prop="losetime">
            <el-switch
              class="switch"
              style="margin-right: 10px"
              v-model="wxName_form.losestatus"
              active-color="#525F7F"
              active-value="0"
              inactive-value="1"
              @change="switchChange($event)"
            >
            </el-switch>
            <el-date-picker
              v-if="wxName_form.losestatus == 1"
              v-model="wxName_form.losetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :clearable="true"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelChangeWx">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="saveWxUser"
            >{{ !is_add ? "保 存" : "确 定" }}</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      dialogFormVisible: false,
      userid: "",
      unionid: "",
      usercode: "",
      dialog_top: "15vh",
      createname: "",
      createName: "",
      nickName: "",
      companyName: "",
      acc_num: 0,
      accountShow: false,
      innerVisible: false,
      accountAll: false,
      accLoading: false,
      userName: "",
      accountList: [],
      users: [],
      allUsers: [],
      account: [],
      userObj: {},
      accountNum: 0,
      userVisible: false,
      is_add: true,
      isScreen: false,
      isRadio: false,
      wxName_form: {
        createname: "",
        phone: "",
        losetime: "",
        losestatus: "0",
        userid: "0"
      },
      allChecked: false, // 是否全选
      batchBtnShow: false, // 是否显示批量按钮
      searchUsers: [], // 批量选择的用户
      // 表单检验规则
      rules: {
        // createname: [
        //     { required: true, message: '请输入使用人', trigger: 'blur' },
        // ],
        losetime: [{ required: false, message: "请选择日期", trigger: "blur" }]
      }
    };
  },
  watch: {
    users: {
      deep: true,
      handler(val) {
        this.accountNum = 0;
        val.forEach(company => {
          this.accountNum += company.activeUser.length;
        });
        this.accountAll = this.accountNum == this.account_totle;
      }
    },
    // 处理全选/非全选
    allChecked(val) {
      if (val && !this.tableData.length) {
        this.allChecked = false;
        this.$hint("没有可选数据!", "info");
        return;
      }
      if (!this.isRadio) {
        this.batchBtnShow = val;
        this.tableData.forEach(item => {
          item.checked = val;
        });
      }
    }
  },
  created() {
    this.getAllUser();
  },
  methods: {
    initList() {
      this.page = 1;
      this.getList();
    },
    // 获取微信用户列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.wxUser_list,
        data: {
          userid: "0",
          pageIndex: this.page,
          pageSize: this.pageSize,
          createname: this.createName
          // nickName: this.nickName,
        }
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = [];
          res.data.concent.forEach(val => {
            if (val.losestatus != 0) {
              if (new Date() * 1 > new Date(val.losetime) * 1)
                val.isActivate = -1;
            }
            val.checked = false;
            this.tableData.push(val);
          });
        }
      });
    },
    // 删除微信用户
    deleteWxUser(index, row) {
      this.$http({
        url: this.$api.del_wxUser,
        data: {
          id: row.id,
          unionid: row.unionid || "",
          userid: "0"
        }
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },
    // 查看绑定的账号
    binding(row) {
      this.isBatch = false;
      this.unionid = row.unionid;
      this.usercode = row.usercode;
      if (row.nickName) {
        this.createname = row.createname + "（ " + row.nickName + " ）";
      } else {
        this.createname = row.createname + "（ 未绑定 ）";
      }
      this.accountShow = true;
      this.getAccountList();
    },
    // 获取所有账号
    getAllUser() {
      this.$http({
        url: this.$api.users,
        data: {
          userName: "",
          companyname: ""
        }
      }).then(res => {
        if (res.code == 0) {
          this.allUsers = [];
          this.account_totle = 0;
          res.data.forEach(val => {
            val.companyAll = false;
            val.activeUser = [];
            val.show = false;
            this.allUsers.push(val);
            val.users.forEach(user => {
              this.account_totle++;
              this.userObj[user.userId] = user.userName;
            });
          });
        }
      });
    },
    // 获取账号列表
    getAccountList() {
      this.accLoading = true;
      this.$http({
        url: this.$api.intUser_list,
        data: {
          unionid: this.unionid,
          userCode: this.usercode
        }
      }).then(res => {
        this.accLoading = false;
        if (res.code == 0) {
          this.accountList = [];
          this.acc_num = 0;
          res.data.forEach(val => {
            this.acc_num += val.users.length;
            val.activeUser = [];
            val.users.forEach(user => {
              val.activeUser.push(user.userId);
            });
            this.accountList.push(val);
          });
        }
      });
    },
    // 点击增加账号
    addAccount() {
      this.userName = "";
      this.companyName = "";
      (this.isScreen = false),
        (this.users = JSON.parse(JSON.stringify(this.allUsers)));
      this.users.forEach(company => {
        company.users.forEach(user => {
          this.accountList.forEach(val => {
            if (company.companyid == val.companyid) {
              company.activeUser = val.activeUser;
              if (company.activeUser.length == company.users.length)
                company.companyAll = true;
            }
          });
        });
      });
      this.innerVisible = true;
    },
    // 保存、确定
    save() {
      if (this.accountNum == 0) {
        this.$message("请选择账号");
        return;
      }
      this.btnLoading = true;
      let data = [];
      this.users.forEach(company => {
        if (company.activeUser.length != 0) {
          let obj = {
            companyid: company.companyid,
            companyname: company.companyname,
            status: company.status,
            users: []
          };
          company.activeUser.forEach(id => {
            obj.users.push({
              userName: this.userObj[id],
              userId: id
            });
          });
          data.push(obj);
        }
      });
      if (this.isBatch) {
        // 批量
        this.batchEditAccount(data);
      } else {
        // 非批量
        this.editAccount(data);
      }
    },
    // 新增、编辑账号
    editAccount(companies) {
      this.$http({
        url: this.$api.edit_acc,
        data: {
          unionid: this.unionid,
          userCode: this.usercode,
          companies
        }
      })
        .then(res => {
          this.btnLoading = false;
          if (res.code == 0) {
            this.innerVisible = false;
            this.getAccountList();
            this.$hint("保存成功");
          } else {
            this.$hint(res.code, "err");
          }
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    // 批量新增、编辑账号
    batchEditAccount(companies) {
      this.$http({
        url: this.$api.batch_edit,
        data: {
          wxCompanyQueries: this.searchUsers,
          companies
        }
      })
        .then(res => {
          this.btnLoading = false;
          if (res.code == 0) {
            this.allChecked = false;
            this.innerVisible = false;
            this.$hint("保存成功");
          } else {
            this.$hint(res.code, "err");
          }
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    // 删除账号
    delAccount(item, index, user, i) {
      this.$http({
        url: this.$api.del_acc,
        data: {
          // companyId: item.companyid,
          // unionid: this.unionid,
          userCode: item.userCode,
          userId: user.userId
        }
      })
        .then(res => {
          if (res.code == 0) {
            this.accountList[index].users.splice(i, 1);
            if (this.accountList[index].users.length == 0)
              this.accountList.splice(index, 1);
            this.acc_num = 0;
            this.accountList.forEach(val => {
              this.acc_num += val.users.length;
            });
            this.$hint("删除成功");
          } else {
            this.$hint(res.code + "：" + res.message, "err");
          }
        })
        .catch(err => {});
    },
    // 点击添加用户
    addUser() {
      this.userVisible = true;
      this.is_add = true;
      this.wxName_form = {
        createname: "",
        phone: "",
        losetime: "",
        losestatus: "0",
        userid: "0"
      };
      this.rules.losetime[0].required = false;
    },
    // 点击编辑微信用户
    editWxUser(index, row) {
      this.userVisible = true;
      this.is_add = false;
      this.wxName_form = JSON.parse(JSON.stringify(row));
    },
    // 更改有效时间
    switchChange(e) {
      e == 0
        ? (this.rules.losetime[0].required = false)
        : (this.rules.losetime[0].required = true);
      if (e == 0) this.$refs["wxName_form"].clearValidate(["losetime"]);
    },
    // 取消新增、编辑微信用户
    cancelChangeWx() {
      this.userVisible = false;
      this.rules.losetime[0].required = false;
      this.$refs["wxName_form"].clearValidate(["losetime"]);
    },
    // 确定新增、编辑微信用户
    saveWxUser() {
      this.$refs.wxName_form.validate(valid => {
        if (valid) {
          if (
            Boolean(this.wxName_form.phone) &&
            !/^1[3456789]\d{9}$/.test(this.wxName_form.phone)
          ) {
            this.$hint("请输入正确的手机号", "err");
            return;
          }
          this.addWxUserReq();
        } else {
          return false;
        }
      });
    },
    // 添加/编辑微信用户
    addWxUserReq() {
      this.btnLoading = true;
      let formData = JSON.parse(JSON.stringify(this.wxName_form));
      let url = this.$api.add_wxUser;
      let data = {
        userid: "0",
        createname: formData.createname,
        phone: formData.phone,
        losetime: formData.losetime,
        losestatus: formData.losestatus
      };
      if (!this.is_add) {
        url = this.$api.edit_wxUser;
        data.usercode = formData.usercode;
        data.id = formData.id;
      }
      this.$http({
        url,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.userVisible = false;
          this.$refs.wxName_form.resetFields();
          this.wxName_form.losetime = "";
          this.wxName_form.losestatus = "0";
          this.$refs["wxName_form"].clearValidate(["losetime"]);
          let hint_text = "添加成功";
          if (!this.is_add) hint_text = "保存成功";
          this.$hint(hint_text);
          this.page = 1;
          this.getList();
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 复制成功
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    // 复制失败
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    },
    // 选择公司所有账号
    selectCompanyAll(e, company) {
      company.activeUser = [];
      if (e) {
        company.users.forEach(val => {
          company.activeUser.push(val.userId);
        });
      }
    },
    // 选择账号
    selectAccount(e, company) {
      if (e) {
        if (company.activeUser.length == company.users.length)
          company.companyAll = true;
      } else {
        company.companyAll = false;
      }
    },
    // 选择所有账号
    selectAllAccount(e) {
      this.users.forEach(company => {
        company.activeUser = [];
        if (e) {
          company.companyAll = true;
          company.users.forEach(user => {
            company.activeUser.push(user.userId);
          });
        } else {
          company.companyAll = false;
        }
      });
    },
    // 搜索账号
    searchAcc() {
      this.isScreen = false;
      let userNum = 0;
      this.users.forEach(company => {
        company.show = false;
        if (this.companyName != "") {
          if (company.companyname.indexOf(this.companyName) != -1) {
            company.show = true;
            this.isScreen = true;
            userNum++;
          }
        }
        if (this.userName != "") {
          company.users.forEach(user => {
            if (user.userName && user.userName.indexOf(this.userName) != -1) {
              company.show = true;
              this.isScreen = true;
              userNum++;
            }
          });
        }
      });
      if ((this.companyName != "" || this.userName != "") && userNum == 0) {
        this.$message({
          message: "没有检索结果",
          type: "success"
        });
      }
    },
    // 批量选择用户
    async selectUser() {
      this.isRadio = true;
      let num = 0;
      this.tableData.forEach(item => {
        if (item.checked) num++;
      });
      this.allChecked = num == this.tableData.length;
      this.batchBtnShow = num > 0;
      await this.$nextTick();
      this.isRadio = false;
    },
    // 点击批量编辑
    handleBatch() {
      this.isBatch = true;
      this.users = JSON.parse(JSON.stringify(this.allUsers));
      this.innerVisible = true;
      this.searchUsers = [];
      this.tableData.forEach(item => {
        if (item.checked) {
          this.searchUsers.push({
            unionid: item.unionid,
            userCode: item.usercode
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.head {
  > div {
    display: flex;
    align-items: center;
    .screening_box {
      margin-right: 15px;
    }
  }
}
.paging_box {
  position: relative;
  .batch_handle {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    .batch_btn {
      margin-left: 20px;
    }
  }
}
.add_wxUser {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    font-size: 12px;
    color: #525f7f;
  }
}
.account_list {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  min-height: 100px;
  max-height: 55vh;
  overflow-y: scroll;
  > li {
    min-width: 250px;
    margin: 0 15px 15px 0;
    .clearfix {
      color: #525f7f;
      font-weight: bold;
    }
    .num {
      font-weight: 500;
      font-size: 12px;
    }
    .user {
      height: 50px;
      overflow-y: scroll;
      > li {
        margin-bottom: 10px;
        color: #525f7f;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 10px;
        box-sizing: border-box;
        &:nth-last-child(1) {
          margin-bottom: 0px;
        }
        .del_icon {
          font-size: 12px;
          color: #eee;
          transition: all 0.3s;
        }
        &:hover {
          .del_icon {
            color: #525f7f;
          }
        }
      }
    }
  }
}
.dialog-footer {
  position: relative;
  &::before {
    content: "";
    width: 100%;
    height: 1px;
    background: #eee;
    position: absolute;
    top: -20px;
    left: 0;
  }
}
.content_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cascader_box {
  max-height: 55vh;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  padding-bottom: 10px;
  > li {
    width: 30%;
    margin-bottom: 10px;
    margin-right: 20px;
    box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #f1f1f1;
    border-radius: 6px;
    padding: 10px 10px 0 10px;
    box-sizing: border-box;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
    .checkAll {
      color: rgba(82, 95, 127, 0.7);
    }
    .child_box {
      margin-top: 10px;
      padding-left: 25px;
    }
  }
  .border_hint {
    border: 1px solid #525f7f;
    background: rgba(82, 95, 127, 0.05);
  }
}
</style>
<style>
.checkAll .el-checkbox__label {
  font-size: 13px;
}
.checkAll .el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(82, 95, 127, 0.9);
}
.child_box .el-checkbox__input.is-checked + .el-checkbox__label {
  font-weight: bold;
}
.child_box .el-checkbox {
  margin-right: 10px;
  margin-bottom: 10px;
}
.child_box .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px;
}

.checkAll .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgba(82, 95, 127, 0.5);
  border-color: rgba(82, 95, 127, 0.5);
}
.screening_box .el-input__inner {
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/internalUser.vue